<script>
	import BorderSelection from "./BorderSelection.svelte";
	import ImageUploadDownload from "./ImageUploadDownload.svelte";

	let selectedBorder = new Image();
</script>

<svelte:head>
	<title>Pic Borderer</title>
</svelte:head>

<main>
	<div class="grid-container">
		<div class="header">
			<img src="/sailpoint-logo.png" alt="SailPoint Logo" />
			<h1>DIBs - Pic Borderer</h1>
		</div>
		<div class="left-content">
			<ImageUploadDownload border={selectedBorder} />
		</div>

		<div class="right-content">
			<BorderSelection
				on:selectBorder={(e) => (selectedBorder = e.detail.selection)}
			/>
		</div>
	</div>
</main>

<style>
	@font-face {
		font-family: "Poppins";
		src: url("/Poppins-Medium.ttf");
	}

	:global(body) {
		font-family: "Poppins";
		color: #425373;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background: linear-gradient(135deg, #0032a1, #cb27b2);
		overflow: hidden; /* Prevent scrolling */
		text-align: center;
		caret-color: transparent;
		cursor: default;
	}

	main {
		width: 90%;
		height: 90%;
		background-color: white;
		padding: 20px;
		border-radius: 10px;
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
	}

	.grid-container {
		display: grid;
		grid-template-areas:
			"header header header"
			"left right right";
		gap: 10px;
		padding: 10px;
		grid-template-columns: 30% 60%;
	}

	.header {
		grid-area: header;
		height: 6%;
		/* border: solid black; */
	}

	.header img {
		width: 200px;
		height: auto; /* Maintain aspect ratio */
	}

	.header h1 {
		text-align: center;
		font-size: 24px;
		margin-top: 0px; /* Space between image and text */
		padding: 0px;
	}

	.left-content {
		grid-area: left;
		/* border: solid black; */
	}

	.right-content {
		grid-area: right;
		/* border: solid black; */
	}
</style>
